import styled from 'styled-components';

export const Container = styled.div`
  padding-top: ${({ theme }) => theme.spacing(2.5)};
  padding-bottom: ${({ theme }) => theme.spacing(2.5)};
  padding-left: ${({ theme }) => theme.spacing(1.75)};
  padding-right: ${({ theme }) => theme.spacing(1.75)};
`;
